"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ProductsList_1 = __importDefault(require("../ProductsList"));
var react_redux_1 = require("react-redux");
var content_1 = require("../../../ProductsApp/ducks/content");
var ProductConstructor_1 = __importDefault(require("../ProductConstructor"));
var ProductInfo_1 = __importDefault(require("../ProductInfo"));
var ProductContainer = function (_a) {
    var innerRef = _a.innerRef;
    var content = (0, react_redux_1.useSelector)(content_1.contentSelector);
    var dispatch = (0, react_redux_1.useDispatch)();
    var currentItem = content.items
        ? content.items.find(function (item) { return item.singular == content.activeItem; })
        : content;
    return (react_1.default.createElement(Container, { ref: innerRef },
        react_1.default.createElement(ProductsList_1.default, { activeItem: content.activeItem, onClick: function (name) { return dispatch((0, content_1.changeItem)(name)); } }),
        react_1.default.createElement(CurrentProduct, null,
            react_1.default.createElement(ProductConstructor_1.default, { content: currentItem }),
            react_1.default.createElement(ProductInfo_1.default, __assign({}, currentItem)))));
};
var CurrentProduct = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 70%;\n  gap: 70px;\n\n  @media (max-width: 740px) {\n    width: 100%;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 70%;\n  gap: 70px;\n\n  @media (max-width: 740px) {\n    width: 100%;\n  }\n"])));
var Container = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  margin-top: 60px;\n\n  @media (max-width: 740px) {\n    flex-direction: column;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  margin-top: 60px;\n\n  @media (max-width: 740px) {\n    flex-direction: column;\n  }\n"])));
exports.default = ProductContainer;
var templateObject_1, templateObject_2;
